import PropTypes from 'prop-types';

import { useInView } from 'react-intersection-observer';

const LazyLoad = ({
  height = 0,
  offset = 0,
  once = true,
  as: Tag = 'div',
  className = '',
  children
}) => {
  const { ref, inView } = useInView({
    triggerOnce: once,
    rootMargin: `${offset}px`
  });

  return (
    <Tag ref={ref} className={className}>
      {inView ? children : <div style={{ height }} />}
    </Tag>
  );
};

LazyLoad.propTypes = {
  height: PropTypes.number,
  offset: PropTypes.number,
  once: PropTypes.bool,
  children: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.node),
    PropTypes.node
  ]).isRequired,
  className: PropTypes.string,
  as: PropTypes.string
};

export default LazyLoad;
